"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _index = require("../index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var PermissionCheckboxInput = function PermissionCheckboxInput(props) {
  var field = props.field,
    form = props.form,
    label = props.label,
    labelNotBold = props.labelNotBold,
    showErrorImmediately = props.showErrorImmediately;
  var error = form.errors[field.name];
  var showError = !!(error && (form.submitCount > 0 || showErrorImmediately));
  var additionalProps = {};
  var pData = _index.permissionsData.find(function (p) {
    return "['".concat(p.permission, "']") === field.name;
  });
  var triggeringPermissions = _index.permissionsData.filter(function (p) {
    return p.toggleFieldAliasesWhenSet && p.toggleFieldAliasesWhenSet.includes(pData.alias);
  });
  var isDisabled = triggeringPermissions.some(function (tPerm) {
    return form.values[tPerm.permission];
  });
  (0, _react.useEffect)(function () {
    if (isDisabled && !field.value) {
      form.setFieldValue(field.name, true);
    }
  }, [isDisabled, field.value]);
  function onChange() {
    var localOnChange = field.onChange;
    if (pData.toggleFieldAliasesWhenSet) {
      localOnChange = function localOnChange() {
        if (field.value === false) {
          // Toggle on and toggle aliased fields on, too
          form.setFieldValue(field.name, true);
          pData.toggleFieldAliasesWhenSet.forEach(function (alias) {
            var pDataFromAlias = _index.permissionsData.find(function (p) {
              return p.alias === alias;
            });
            var aliasFormikName = "['".concat(pDataFromAlias.permission, "']");
            form.setFieldValue(aliasFormikName, true);
          });
          return;
        }

        // Toggle off and reset to initial values
        form.setFieldValue(field.name, false);
        pData.toggleFieldAliasesWhenSet.forEach(function (alias) {
          var pDataFromAlias = _index.permissionsData.find(function (p) {
            return p.alias === alias;
          });
          var aliasFormikName = "['".concat(pDataFromAlias.permission, "']");
          form.setFieldValue(aliasFormikName, form.initialValues[pDataFromAlias.permission]);
        });
      };
    }
    return localOnChange;
  }

  /* ////////////////////////////////////////////////////////////////////////
  // RENDER ////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////// */

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'mb-3 ' + (showError ? 'is-invalid' : '')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label",
    style: labelNotBold && {
      fontWeight: 'normal'
    }
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, additionalProps, (0, _omit2["default"])(field, ['onChange']), {
    checked: field.value || false,
    disabled: isDisabled,
    onChange: onChange(),
    type: "checkbox"
  })), "\xA0\xA0", label), showError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-danger"
  }, error));
};
PermissionCheckboxInput.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  label: _propTypes["default"].node,
  labelNotBold: _propTypes["default"].bool,
  showErrorImmediately: _propTypes["default"].bool
};
var _default = exports["default"] = PermissionCheckboxInput;